import React from "react";
import Config from "./Config";


export default function Preloader() {
    return (
        <div className="preloader-wrapper">
            <img src={Config('ASSETS_URL')+'/images/preloader.gif'}/>
            <h1>Počkejte, prosím…</h1>
        </div>
    )
}